import PermissionGate from '../../../helpers/PermissionGate'
import { ArrowRightOutlined } from '@ant-design/icons'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import { useState } from 'react'
import BalanceOverwriteModal from './BalanceOverwriteModal'

const BalanceOverwriteButton = (props) => {
  const [modalVisible, setModalVisible] = useState(false)

  return (
    <>
      <PermissionGate
        requiredRole='dashboardEditor'
        readOnly={
          <Typography>
            Balance Overwrite
            <ArrowRightOutlined />
          </Typography>
        }
        spanSettings={{
          style: { cursor: 'not-allowed', fontWeight: '600', fontSize: '14px', color: 'rgba(0,0,0,0.25)' },
        }}
        toolTipPlacement='top'
        toolTipText='Only admins and dashboard editors may overwrite bank account balances.'
      >
        <Link underline='none' onClick={() => setModalVisible(true)}>
          Balance Overwrite <ArrowRightOutlined />
        </Link>
      </PermissionGate>
      {modalVisible && (
        <BalanceOverwriteModal
          visible={modalVisible}
          handleCancelModal={() => setModalVisible(false)}
          accountDetails={props.accountDetails}
          setBankAccountData={props.setBankAccountData}
          bankAccountId={props.bankAccountId}
        />
      )}
    </>
  )
}

export default BalanceOverwriteButton
